module.exports = __webpack_public_path__ + "assets/6f83ec4a5483e919276744b75f6b3539.mp3";